export default "__VITE_ASSET__BhS$8D0u__"